"use strict";
var _a, _b, _c, _d, _e;
Object.defineProperty(exports, "__esModule", { value: true });
exports.MedicalDoc = exports.DocType = void 0;
const tslib_1 = require("tslib");
const typeorm_1 = require("typeorm");
const customer_entity_1 = require("../customers/customer.entity");
const user_entity_1 = require("../users/user.entity");
var DocType;
(function (DocType) {
    DocType["PRESCRIPTION"] = "prescription";
    DocType["LAB_REPORT"] = "lab_report";
    DocType["MEDICAL_HISTORY"] = "medical_history";
    DocType["OTHER"] = "other";
})(DocType || (exports.DocType = DocType = {}));
let MedicalDoc = class MedicalDoc {
};
exports.MedicalDoc = MedicalDoc;
tslib_1.__decorate([
    (0, typeorm_1.PrimaryGeneratedColumn)(),
    tslib_1.__metadata("design:type", Number)
], MedicalDoc.prototype, "id", void 0);
tslib_1.__decorate([
    (0, typeorm_1.ManyToOne)(() => customer_entity_1.Customer, (c) => c.medicalDocs, { onDelete: 'CASCADE' }),
    tslib_1.__metadata("design:type", typeof (_a = typeof customer_entity_1.Customer !== "undefined" && customer_entity_1.Customer) === "function" ? _a : Object)
], MedicalDoc.prototype, "customer", void 0);
tslib_1.__decorate([
    (0, typeorm_1.ManyToOne)(() => user_entity_1.User, { nullable: true }),
    tslib_1.__metadata("design:type", typeof (_b = typeof user_entity_1.User !== "undefined" && user_entity_1.User) === "function" ? _b : Object)
], MedicalDoc.prototype, "uploadedBy", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ type: 'enum', enum: DocType }),
    tslib_1.__metadata("design:type", String)
], MedicalDoc.prototype, "docType", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ length: 200 }),
    tslib_1.__metadata("design:type", String)
], MedicalDoc.prototype, "fileName", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ type: 'text' }),
    tslib_1.__metadata("design:type", String)
], MedicalDoc.prototype, "fileUrl", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ length: 10 }),
    tslib_1.__metadata("design:type", String)
], MedicalDoc.prototype, "fileExtension", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ nullable: true }),
    tslib_1.__metadata("design:type", typeof (_c = typeof Date !== "undefined" && Date) === "function" ? _c : Object)
], MedicalDoc.prototype, "validUntil", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ type: 'text', nullable: true }),
    tslib_1.__metadata("design:type", String)
], MedicalDoc.prototype, "notes", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ default: true }),
    tslib_1.__metadata("design:type", Boolean)
], MedicalDoc.prototype, "isActive", void 0);
tslib_1.__decorate([
    (0, typeorm_1.CreateDateColumn)(),
    tslib_1.__metadata("design:type", typeof (_d = typeof Date !== "undefined" && Date) === "function" ? _d : Object)
], MedicalDoc.prototype, "createdAt", void 0);
tslib_1.__decorate([
    (0, typeorm_1.UpdateDateColumn)(),
    tslib_1.__metadata("design:type", typeof (_e = typeof Date !== "undefined" && Date) === "function" ? _e : Object)
], MedicalDoc.prototype, "updatedAt", void 0);
exports.MedicalDoc = MedicalDoc = tslib_1.__decorate([
    (0, typeorm_1.Entity)('medical_docs')
], MedicalDoc);
